<template>
  <div>
    <form-section :title="$t('Automations_Import_Title_Schedule')">
      <recurrence-settings
        :model="model.schedule"
        :timezone="$store.state.app.project.timezone"
        :disabled="readonly"
      />
    </form-section>
    <form-section
      :title="$t('Automations_Import_Title_CampaignTrigger')"
      v-if="
        $hasFeature('featureAutomationCampaignExecution') &&
          model.type === 'profiles'
      "
    >
      <campaign-execution-settings :model="model.config" :disabled="readonly" />
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RecurrenceSettings from '@/modules/automations/components/RecurrenceSettings'
import CampaignExecutionSettings from '@/modules/automations/components/CampaignExecutionSettings'
export default {
  name: 'StepImportSchedule',

  components: {
    RecurrenceSettings,
    CampaignExecutionSettings,
    FormSection
  },

  props: {
    steps: {
      type: Array,
      required: true
    },

    model: {
      type: Object,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false,
      required: false
    },

    isEdit: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  mounted() {
    this.allowContinue()
  },

  methods: {
    allowContinue() {
      this.$emit('can-continue', { value: true })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/automations/components/StepImportSchedule.vue